var map = {
	"./alert.svg": 43988,
	"./blue_tick.svg": 38406,
	"./flags/blue.svg": 36245,
	"./flags/cps.svg": 74255,
	"./flags/green.svg": 30291,
	"./flags/green_strike_through.svg": 99137,
	"./flags/grey.svg": 68490,
	"./flags/na.svg": 64057,
	"./flags/no.svg": 21436,
	"./flags/orange.svg": 65856,
	"./flags/orange_exclamation_mark.svg": 81745,
	"./flags/orange_stop.svg": 89949,
	"./flags/pf.svg": 82766,
	"./flags/pink.svg": 21326,
	"./flags/red.svg": 10582,
	"./flags/sc.svg": 69074,
	"./flags/sh.svg": 75799,
	"./flags/sib.svg": 17406,
	"./flags/tmp.svg": 97395,
	"./flags/va.svg": 6406,
	"./flags/yellow.svg": 81272,
	"./flags/yellow_strike_through.svg": 61761,
	"./green_tick.svg": 36533,
	"./icon-school.svg": 74337,
	"./logo-dark.svg": 97705,
	"./logo.svg": 69574,
	"./school-logo.svg": 74722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;